import { TextContainer, Modal, Button } from '@superops/ui-design-system';

import { Delete } from '@styled-icons/material';
import React, { useCallback, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getTranslatedText, BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

function DeleteConfirmation(props) {
  const [active, setActive] = useState(false);
  const { intl, confirm, loading } = props;

  const handleChange = useCallback(() => setActive(!active), [active]);

  return (
    <div>
      <Button
        onClick={handleChange}
        icon={<SVGIcon name="MoveTrash" />}
        loading={loading}
      >
        <FormattedMessage id="common.delete" />
      </Button>
      <Modal
        open={active}
        onClose={handleChange}
        title={getTranslatedText(intl, 'ticket.details.delete.text')}
        primaryAction={{
          destructive: true,
          content: getTranslatedText(intl, 'common.delete'),
          onAction: () => {
            confirm();
            handleChange();
          }
        }}
        secondaryActions={[
          {
            content: getTranslatedText(intl, 'common.cancel'),
            onAction: handleChange
          }
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>
              <FormattedMessage id="ticket.details.delete.confirm" />
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    </div>
  );
}

export default injectIntl(DeleteConfirmation);
